import { render, staticRenderFns } from "./chat-room-list-search.vue?vue&type=template&id=afff2eae"
import script from "./chat-room-list-search.vue?vue&type=script&lang=js"
export * from "./chat-room-list-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports